import { HTTP } from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = 'QtyAdjustment';

const qtyAdjustmentStore = {
    namespaced: true,
    state: {
        totalItem: 0,
        q: {
            tableNeedQuery: tableName,
            isOuterJoin: false,
            searchCriteria: "",
            orderBy: "",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions: {
        getQtyAdjustmentList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/GetAdjList', { b_AdjQty: param }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getSOList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/getsolist', { entNum: param.entNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        copySODetails({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/copyso', { SONum: param.SONum, entNum: param.entNum, loc: param.loc }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getQtyAdjustmentDetailsByTxNum({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/GetStockAdjust', { s_txNumber: param.txNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getEventCodeList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/SO/GetEventList').then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getRefSOList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/getrefsolist', { entNum: param.entNum, itemNum: param.itemNum }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        addQtyAdjustment({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/AddStockAdjust', JSON.stringify(param)).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        UpdateStockAdjust({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/UpdateStockAdjust', JSON.stringify(param)).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        deleteQtyAdjustment({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/DeleteStockAdjust', JSON.stringify({ s_txNumber: param.txNum })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        postQtyAdjustment({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/poststktxf', JSON.stringify({ txHdr: param.header })).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        exportFile({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/mm/export', state.q, { responseType: 'blob' }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getOnHandQty({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/item/GetItemStock', { itemNum: param.ItemNum}).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
    }
};
export default qtyAdjustmentStore;